export const PlacesMarkerTimeout = 60000; // 1 minute
